import { PageHeader } from '@/components/ui/page-header';
import { useCurrentUser } from '@/lib/auth';
import { usePageTitle } from '@/lib/use-page-title';
import { SuppliersPanel } from '@/pages/settings';

export function SuppliersPage() {
  usePageTitle('Suppliers');
  const me = useCurrentUser();
  const isAdmin = me.data?.user.role === 'ADMIN';

  return (
    <>
      <PageHeader
        title="Suppliers"
        subtitle={
          isAdmin
            ? 'Search, filter, create, edit and deactivate supplier master records. Categories and sub-categories are configured in Settings.'
            : 'Search and view supplier master records. Contact an admin to add or modify suppliers.'
        }
      />
      <SuppliersPanel canMutate={isAdmin} />
    </>
  );
}
